module.exports = __webpack_public_path__ + "84900f33cbb09763b32fc8d8ce05cfc2.svg";